import { render, staticRenderFns } from "./_TraitCard.vue?vue&type=template&id=a89d4208&"
import script from "./_TraitCard.vue?vue&type=script&lang=ts&"
export * from "./_TraitCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports